import getStore from 'Util/Store';

/** @namespace Pwa/Util/ElasticSuite/addPageVars */
export const addPageVars = (vars) => {
    const state = getStore().getState();
    const { smile_elasticsuite_tracker_enabled } = state.ConfigReducer;

    if (!smile_elasticsuite_tracker_enabled) {
        return;
    }

    const { smileTracker } = window;

    if (!vars) {
        // eslint-disable-next-line no-console
        console.warn('ElasticSuite: variables not defined');
        return;
    }

    if (!smileTracker) {
        // eslint-disable-next-line no-console
        console.warn('ElasticSuite: smileTracker not defined');
        return;
    }

    /* init shot */
    smileTracker.sessionInitialized = false;
    smileTracker.trackerSent = false;
    smileTracker.trackerVarsAdded = false;
    smileTracker.vars = {};
    /* ********* */

    vars.forEach(({ name, value }) => {
        smileTracker.addPageVar(name, value);
    });

    smileTracker.sendTag();
};

export default {
    addPageVars,
};
